import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../isabellacoimbra_sobrancelhas/isabellacoimbra_sobrancelhas.module.scss';
import perfil from '../isabellacoimbra_sobrancelhas/src/perfil.png';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const cardImages = [
    {
        id: 1,
        image: require("./src/cards/1.png"),
        link: "/isabellacoimbra_sobrancelhas/agendamento",
        linkInterno: true,
    },
    {
        id: 2,
        image: require("./src/cards/2.png"),
        link: "/isabellacoimbra_sobrancelhas/curso",
        linkInterno: true,
    },
    {
        id: 3,
        image: require("./src/cards/3.png"),
        link: "/isabellacoimbra_sobrancelhas/procedimentos",
        linkInterno: true,
    },
    {
        id: 4,
        image: require("./src/cards/4.png"),
        link: "https://maps.app.goo.gl/LAFh5zcXgfCubPsr5",
        linkInterno: false,
    },
    {
        id: 5,
        image: require("./src/cards/5.png"),
        link: "https://www.instagram.com/isabellacoimbra_sobrancelhas?igsh=MW0xZWU4NTJ0bDlmMA%3D%3D&utm_source=qr",
        linkInterno: false,
    },
];

const Isabellacoimbra_sobrancelhas: React.FC = () => {
    const whatsappLink = `https://wa.me/5517988130264?text=${encodeURIComponent(
        'Olá! Vim pelo seu cartão digital e gostaria de tirar uma dúvida.'
    )}`;

    return (
        <div className={styles.isabellacoimbra_sobrancelhas}>
            <div className={styles.container}>
                <img src={perfil} alt="Perfil" className={styles.perfil} />
                <div className={styles.cards}>
                    {cardImages.map((card, index) =>
                        card.linkInterno ? (
                            <Link to={card.link} key={index} className={styles.card}>
                                <img src={card.image} alt={`Card ${card.id}`} />
                            </Link>
                        ) : (
                            <a href={card.link} target="_blank" rel="noopener noreferrer" key={index} className={styles.card}>
                                <img src={card.image} alt={`Card ${card.id}`} />
                            </a>
                        )
                    )}
                </div>

                <div className={styles.footer}>
                    <a
                        href={whatsappLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.footerWhatsapp}
                        aria-label="WhatsApp"
                    >
                        <div className={styles.footerTop}>
                            <WhatsappIcon height="32" color="#111" />
                            <span className={styles.footerText}>Para mais informações<br />Entre em contato pelo WhatsApp</span>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Isabellacoimbra_sobrancelhas;
